export const SET_LINKEDIN_OPTIMIZER_DATA: string =
  'SET_LINKEDIN_OPTIMIZER_DATA';
export const RESET_LINKEDIN_OPTIMIZER_DATA: string =
  'RESET_LINKEDIN_OPTIMIZER_DATA';
